module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fS8Y5"))).then(() => parcelRequire('1iHdE'));